import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";

const WeeklySaleschart = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { webApi } = useUserPermissions();
  const [sales, setSales] = useState();
  const [chartData, setChartData] = useState<any>(null);

  const jwtToken = Cookies.get("authToken");
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchSales = async () => {
    setIsLoading(true); // Set loading to true
    try {
      const response = await fetch(
        `${webApi}/sed/get_weekly_sales_graph/`,
        options,
      );
      const data = await response.json();
      setSales(data.results);
      const categories = data.results.map((item: { label: any }) => item.label);

      let series = [];
        series = [
          {
            name: "Sales",
            data: data.results.map((item: { sales: any }) => item.sales),
          },
          {
            name: "ETS",
            data: data.results.map(
              (item: { ets: any }) => item.ets ?? 0,
            ),
          },
          {
            name: "SCTS",
            data: data.results.map(
              (item: { scts: any }) => item.scts ?? 0,
            ),
          },
        ];
        // series = [
        //   {
        //     name: "Sales",
        //     data: data.results.map((item: { sales: any }) => item.sales),
        //   },
        //   {
        //     name: "Target",
        //     data: data.results.map((item: { target: any }) => item.target),
        //   },
        // ];

      setChartData({
        chart: {
          height: 350,
          type: "bar",
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            // borderRadius: 6,
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories,
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: (val: number) => `${val}`,
          },
        },
        series,
      });
    } catch (error) {
      console.error("Error fetching Weeekly Sales data:", error);
    } finally {
      setIsLoading(false); // Set loading to false when done
    }
  };

  useEffect(()=>{
    fetchSales();
  },[])

  return (
    <div>
      <div className="row">
        {/* Fees Collection */}
        <div className="col-xxl-6 col-xl-6 d-flex">
          <div className="card flex-fill">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h4 className="card-title">Weekly Sales</h4>
            </div>

            <div className="card-body pb-0">
              {isLoading ? (
                <div
                  style={{
                    height: "350px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : chartData?.series?.length ? (
                <ReactApexChart
                  options={chartData}
                  series={chartData.series}
                  type="bar"
                  height={350}
                />
              ) : (
                <div className="text-center py-4">No data available</div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="col-xxl-6 col-xl-6 d-flex">
          <div className="card flex-fill">
            <div className="card-header  d-flex align-items-center justify-content-between">
              <h4 className="card-title">Weekly Conversation Of Agent</h4>
            </div>
            <div className="card-body pb-0">
              {isLoading ? (
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : (
                <ReactApexChart
                  id="fees-chart"
                  options={WeeklyConversation}
                  series={WeeklyConversation.series}
                  type="bar"
                  height={270}
                />
              )}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default WeeklySaleschart;
